module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed inset-y-0 left-0 z-[999] w-[85%] max-w-[420px] transform -translate-x-full transition-transform duration-300 will-change-transform\n         bg-gradient-to-b from-[#2972db] to-[#163D75]",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "relative h-full flex flex-col px-4 py-4 text-white"
  }, [_c('button', {
    staticClass: "absolute top-4 right-4 inline-flex items-center justify-center h-10 w-10 rounded-full bg-white/15 hover:bg-white/25 transition",
    attrs: {
      "id": "close-pannel",
      "aria-label": "Fermer",
      "title": "Fermer"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-close bg-white"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "mt-10 mb-8 flex items-center gap-4",
    attrs: {
      "to": {
        name: 'profil'
      }
    }
  }, [_c('div', {
    staticClass: "h-20 w-20 rounded-full bg-center bg-cover ring-2 ring-white/30",
    style: (("background-image: url(" + (_vm.photoProfil || require('@/img/user-default.png')) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "leading-tight"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.last_name))]), _vm._v(" "), _c('p', {
    staticClass: "text-lg opacity-90"
  }, [_vm._v(_vm._s(_vm.first_name))]), _vm._v(" "), _c('p', {
    staticClass: "text-sm text-blue-200 mt-1"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("ID client :")]), _vm._v("\n                    " + _vm._s(_vm.idOperator) + "-" + _vm._s(_vm.idUser) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-1 overflow-y-auto no-scrollbar pb-6"
  }, [_c('nav', {
    staticClass: "space-y-5 text-xl"
  }, [_c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-home bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Accueil")])]), _vm._v(" "), (_vm.type === 'technicien') ? [_c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'liste-fibsdd'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-gear-contour bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Interventions")])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'ctrl-multi'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-pipe-valve bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Contrôles d'étanchéité multiples")])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'contrat-assemblage'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-file bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Contrat d’assemblage")])])] : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'liste-detenteurs'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-industry bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Détenteurs & installations")])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'liste-bouteilles'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-bouteille-contour bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Bouteilles")])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'restitution-bouteilles'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-bouteille-contour bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Restitution bouteilles en volume")])]), _vm._v(" "), (_vm.type === 'technicien') ? [_c('router-link', {
    staticClass: "flex items-center gap-4 hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'liste-outils'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-outils bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Outillage")])])] : _vm._e()], 2)]), _vm._v(" "), (_vm.canShowSupport) ? _c('router-link', {
    staticClass: "relative flex items-center gap-3 text-lg hover:opacity-90 transition",
    attrs: {
      "to": {
        name: 'support'
      },
      "id": "btnSupportMenu"
    }
  }, [_c('i', {
    staticClass: "inline-block h-7 w-7 mask mask-question bg-blue-200"
  }), _vm._v(" "), _c('span', [_vm._v("Demande support")]), _vm._v(" "), (_vm.badgeCount > 0) ? _c('div', {
    staticClass: "absolute -top-2 left-5 w-5 h-5 rounded-full bg-red-600 border-2 border-white flex items-center justify-center"
  }, [_c('span', {
    staticClass: "text-[10px] font-bold text-white leading-none"
  }, [_vm._v(_vm._s(_vm.badgeCount))])]) : _vm._e()]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f248fd2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Menu.vue
// module id = 1022
// module chunks = 0